import {
  Api
} from '@/core/api.js'
const api = new Api()

// initial state
const state = {
  skeleton: {},
  clubs: {},
  following: localStorage.following ? JSON.parse(localStorage.following) : {},
  categories: [],
  list: [],
  event: {},
  groups: {},
  matches: [],
  rounds: [],
  facilities: {},
  sanctions: []
}

// getters
const getters = {

  getCategories: (state) => (id) => {
    if (typeof id !== 'undefined') {
      return state.skeleton[id]
    }
    return state.skeleton
  },

  getClubs: (state) => (id) => {
    if (typeof id !== 'undefined') {
      return state.clubs[id]
    }
    return state.clubs
  },

  getTeamsFollowing: (state) => {
    var results = []
    for (var clubId in state.following) {
      var teams = state.following[clubId]
      var club = state.clubs[clubId]

      console.log(clubId)

      if (club) {
        for (var idx in teams) {
          var teamId = teams[idx]
          var team = club.teams[teamId]
          var result = {
            club: club,
            team: team
          }
          results.push(result)
        }
      }
    }

    return results
  },

  getMatches: (state) => (id) => {
    if (typeof id.idEvent !== 'undefined') {
      var aMatchs = []
      for (var i in state.matches) {
        var match = state.matches[i]
        console.log(state.rounds[ match.round_id ].phase_id != null ? phases[ round.phase_id ].name : groups[ round.group_id ].name)
        console.log(state.rounds[ match.round_id ].phase_id)
        console.log(state.rounds[match.round_id].group_id)
      }
      var newArray = []

      if (state.rounds[id.idGroup] != undefined) {
        newArray = aMatchs.filter(function (el) {
          return el.round_id == state.rounds[id.idGroup].group_id
        })
      }
    } else {
      return state.matches
    }
  },

  getMatchesByGroup: (state, getters, rootState) => (id) => {
    var aMatches = {}
    for (var k in state.matches) {
      var match = state.matches[ k ]

      if (state.rounds[ match.round_id ].group_id == id) {
        if (typeof aMatches[ match.round_id ] === 'undefined') {
          aMatches[ match.round_id ] = {
            name: state.rounds[ match.round_id ].name,
            fullname: state.rounds[ match.round_id ].fullname,
            matches: []
          }
        }

        aMatches[ match.round_id ].matches.push(match)
      }
    }

    return aMatches
  },

  getEvent: (state, getters, rootState) => {
    return state.event
  },

  getListRounds: (state, getters, rootState) => (id) => {
    if (typeof id !== 'undefined') return state.rounds[id]
    return state.rounds
  },

  getList: (state) => (id) => {
    if (typeof id !== 'undefined') {
      return state.list[id]
    }
    return state.list
  },

  getGroupsByCategory: (state) => (id) => {
    if (typeof id !== 'undefined') {
      var group = Object.values(state.groups).filter(obj =>
        obj.category_id == id
      )
      return group
    } else return state.groups
  },

  getStandingsByGroup: (state) => (id) => {
    var aGroups = []
    if (typeof id !== 'undefined') {
      var standing = Object.values(state.groups).filter(obj =>
        obj.id == id
      )
      for (var i in standing) {
        aGroups.push({
          id: standing[i].id,
          name: standing[i].name,
          max_teams: standing[i].max_teams,
          type: 'groups'
        })
        for (var key in standing[i].teams) {
          var team = standing[i].teams[key]
          aGroups.push({
            id: 'tt' + team.id,
            group: standing[i].name,
            name: team.name,
            team: team.team,
            position: team.position,
            category_id: standing[i].category_id
          })
        }
      }
      return aGroups
    }
  },

  get_category_by_id: (state) => (id) => {
    return state.categories[ id ]
  },

  get_group_by_id: (state) => (id) => {
    return state.groups[ id ]
  },

  get_facility_by_id: (state) => (id) => {
    if (typeof state.facilities[ id ] === 'undefined') return { name: '-' }
    return state.facilities[ id ]
  },

  get_match_by_id: (state) => (id) => {
    var match = state.matches[ id ]
    var local_team = state.groups[ state.rounds[ match.round_id ].group_id ].teams[ match.local_team_id ]
    var away_team = state.groups[ state.rounds[ match.round_id ].group_id ].teams[ match.away_team_id ]
    match.teams = {
      local_team: (local_team.team != null ? local_team.team : local_team),
      away_team: (away_team.team != null ? away_team.team : away_team)
    }

    return match
  },

  getSanctions: (state) => {
    return state.sanctions
  }

}

const actions = {

  loadMatchesByIdEvent ({
    commit
  }, params) {
    return api.get('competition/match/event/' + params).then((response) => {
      if (response.status) {
        var data = response.data
        for (var i in data) {
          data[i].visible = true
        }
        return commit('setMatches', data)
      }
    }).catch((err) => {})
  },

  loadRounds ({
    commit,
    getters,
    rootState
  }, event_id) {
    return api.get('competition/round/event/' + event_id).then(function (response) {
      if (response.status) {
        var data = response.data
        return commit('setListRounds', data)
      }
    })
  },

  loadEvent ({
    commit
  }, id) {
    return api.get('event/' + id).then((response) => {
      if (response.status) {
        commit('setCategories', response.data.categories)
        return commit('setEvent', response.data)
      }
    }).catch((err) => {})
  },

  loadGroups ({
    commit
  }, id) {
    return api.get('/competition/group/event/' + id).then((response) => {
      if (response.status) {
        return commit('setGroups', response.data)
      }
    }).catch((err) => {})
  },

  loadSkeleton ({ commit }, id) {
    return api.get('miclive/competition/skeleton').then(function (response) {
      if (response.status) {
        return commit('setSkeleton', response.data)
      }
    })
  },
  loadClubs ({ commit }, id) {
    return api.get('miclive/clubs').then(function (response) {
      if (response.status) {
        return commit('setClubs', response.data)
      }
    })
  },

  loadSanctions (context) {
    return api.get('miclive/sanctions').then(function (response) {
      if (response.status) {
        return context.commit('setSanctions', response.data.data)
      }
    })
  }

}

const mutations = {
  setSkeleton (state, value) {
    state.skeleton = value
  },
  setFollowing (state, value) {
    state.following = value
    localStorage.setItem('following', JSON.stringify(value))
  },
  setClubs (state, value) {
    // if (localStorage.following) {
    //   state.following = JSON.parse(localStorage.following)
    // }
    state.clubs = value
  },
  setCategories (state, value) {
    state.categories = value
  },
  setMatches (state, matches) {
    state.matches = matches
  },
  setList (state, list) {
    state.list = list
  },
  setEvent (state, event) {
    state.event = event
  },
  setGroups (state, groups) {
    state.groups = groups
  },
  setListRounds (state, data) {
    state.rounds = data
  },
  setFacilities (state, data) {
    state.facilities = data
  },
  setSanctions (state, data) {
    state.sanctions = data
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
